import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    container: {
      marginTop: 16,
      display: 'flex',
      alignItems: 'center',

      '& .MuiGrid-container': {
        alignItems: 'center',
      },
    },
    table: {
      marginTop: 32,
    },
    dateContent: {
      display: 'flex',
      justifyContent: 'space-around',
    },
    tableRow: {
      width: 100,
      paddingRight: 0,
      paddingLeft: 16,
      fontSize: 12,
      '&:hover': {
        background: `${palette.superLightDeepBlue} !important`,
      },
    },
    tableMessages: {
      paddingRight: 32,
      fontSize: 12,
      width: 300,
    },
    center: {
      display: 'flex',
      justifyContent: 'center',
    },
    timeAndType: {
      width: 80,
      fontSize: 12,
    },
    logsTitle: { margin: '1px 0px 8px 2px' },
  });
